<template>
  <v-list-item two-line>
    <v-list-item-icon><v-icon>mdi-food</v-icon></v-list-item-icon>
    <v-list-item-content>
      <!-- <v-list-item-title>{{item.product.alt_name || item.product.name}}</v-list-item-title> -->
      <v-list-item-title>{{item.name}}</v-list-item-title>
      <v-list-item-subtitle v-for="modi in item.modifiers" :key="modi.id">
        {{modi.quantity}}x {{modi.name}}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="!item.injected">
      <div>
        <v-btn @click="$emit('dec')" :disabled="validating || isDeliveryDish" icon color="primary" small>
          <v-icon>mdi-minus</v-icon>
        </v-btn>
        <span style="min-width: 30px; display: inline-block; text-align: center">{{item.quantity}}</span>
        <v-btn @click="$emit('inc')" :disabled="validating || isDeliveryDish" icon color="primary" small>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </v-list-item-action>
    <span style="min-width: 4.8em; display: inline-block; text-align: right">{{line_total.toFixed(2)}}</span>
  </v-list-item>
</template>

<script>
export default {
  props: {
    item: Object,
    price_address: String,
    validating: Boolean
  },
  computed: {
    line_total(){
      return this.item.sum
    },
    isDeliveryDish() {
      return this.item.id === this.$store.getters.config.r_keeper_references.dish_delivery;
    }
  }
}
</script>